"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _Fonts = require("../utils/Fonts");

var _Timers = require("../utils/Timers");

function _default(Component) {
  var MeasureInputDecorator =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(MeasureInputDecorator, _React$Component);

    function MeasureInputDecorator(props) {
      var _this;

      (0, _classCallCheck2.default)(this, MeasureInputDecorator);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MeasureInputDecorator).call(this, props));
      _this.state = {
        inputWidth: null
      };
      _this.measureInput = _this.measureInput.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleWindowResize = _this.handleWindowResize.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(MeasureInputDecorator, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
        this.measureInput();
        if (!(0, _Fonts.fontsLoaded)()) _Fonts.fontsLoadedPromise.then(this.measureInput);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        // ⚠️ This condition prevents infinite loops! ⚠️
        if (prevState.inputWidth === this.state.inputWidth) {
          this.measureInput(this);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        (0, _Timers.cancelIdleCallback)(this._resizeTimer);
      }
    }, {
      key: "measureInput",
      value: function measureInput() {
        var inputNode = this.props.inputRef.current;
        if (!inputNode) return;
        var inputWidth = inputNode.offsetWidth;

        if (inputWidth !== this.state.inputWidth) {
          this.setState({
            inputWidth: inputWidth
          });
        }
      }
    }, {
      key: "handleWindowResize",
      value: function handleWindowResize() {
        (0, _Timers.cancelIdleCallback)(this._resizeTimer);
        this._resizeTimer = (0, _Timers.requestIdleCallback)(this.measureInput);
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          inputWidth: this.state.inputWidth
        }));
      }
    }]);
    return MeasureInputDecorator;
  }(_react.default.Component);

  var componentName = (0, _getComponentName.default)(Component);
  MeasureInputDecorator.displayName = "MeasureInput(" + componentName + ")";
  MeasureInputDecorator.propTypes = Component.propTypes;
  MeasureInputDecorator.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(MeasureInputDecorator, Component);
  return MeasureInputDecorator;
}

module.exports = exports.default;